import React, { Component } from 'react';
import { Icon, Layout, Row, Col, Button, Table, Card } from 'antd';
import { Link } from 'react-router-dom';
import { withAsyncActions } from 'react-async-client';
import { filter, propEq } from 'ramda';
import { mapIndexed } from 'utils/ramdaAdditions.js';

import { getProjects } from 'actions/asyncActions';
import { project_show, project_add, project_edit } from 'constants/routes';
import Date from 'components/common/fields/Date';
import RouteTitle from 'components/pages/RouteTitle.js';
import Breakpoint from 'components/layout/Breakpoint.js';

function TableCardProject(project, index) {
    return (
        <Card className="table-card" key={project.id}>
            <Row type="flex" justify="space-between">
                <span>{index + 1}</span>
                <div className="table-actions">
                    <Link to={project_show.stringify({id: project.id})}>
                        <Icon type="eye-o" className="m-r-20" />
                    </Link>
                    <Link to={project_edit.stringify({id: project.id})}>
                        <Icon type="edit" />
                    </Link>
                </div>
            </Row>
            <Row className="bold m-t-10">
                <Link to={project_show.stringify({id: project.id})}>
                    {project.name}
                </Link>
            </Row>
            <Row className="m-t-10" align="middle">
                <span className="key">Спецификаций: </span>
                <span>{project.specifications || 0}</span>
            </Row>
            <Row className="key m-t-20">
                <Date date={project.updated_at} />
            </Row>
        </Card>
    )
}

@withAsyncActions({
    getProjects,
}, { dispatchOnMount: true })
export default class Projects extends Component {
    state = {
        finished: 0
    }

    goAddProject = () => {
        this.props.history.push(project_add.stringify());
    }

    columns = [
        {
            title: 'ID',
            dataIndex: 'big_id',
            key: 'big_id',
            className: 'bold',
        },
        {
            title: 'Название',
            dataIndex: 'name',
            key: 'name',
            render: (value, row) => (
                <Link to={project_show.stringify(row)}>
                    {value}
                </Link>
            ),
        },
        {
            title: 'Спецификаций',
            dataIndex: 'specifications',
            key: 'spec',
            render: value => <span>{value || 0}</span>,
        },
        {
            title: 'Дата обновления',
            dataIndex: 'updated_at',
            key: 'update',
            className: 'bold',
            render: value => <Date date={value} />,
        },
        {
            title: 'Действие',
            key: 'actions',
            render: (value, row) => (
                <div className="table-actions">
                    <Link to={project_show.stringify(row)}>
                        <Icon type="eye-o" />
                    </Link>
                    <Link to={project_edit.stringify(row)}>
                        <Icon type="edit" />
                    </Link>
                </div>
            )
        },
    ];


    render() {
        const { finished } = this.state;
        const { data, meta } = this.props.getProjects;

        const dataSource = filter(propEq('is_finished', finished), data.projects || []);

        return (
            <Layout className="projects page main-content">
                <Breakpoint min="lg">
                    <RouteTitle className="title-route title-page" />
                </Breakpoint>

                <Row className="controls m-b-20">
                    <Button type="primary" onClick={this.goAddProject}>
                        Добавить проект <Icon type="plus" />
                    </Button>
                </Row>

                <Row>
                    <Col lg={24} md={24} sm={24} xs={24}>
                        <Breakpoint min="sm">
                            <Table
                                rowKey='id'
                                columns={this.columns}
                                loading={meta.pending}
                                dataSource={dataSource}
                                pagination={false}
                            />
                        </Breakpoint>
                    </Col>
                </Row>
                <Breakpoint max="sm">
                    {mapIndexed(TableCardProject, dataSource)}
                </Breakpoint>
            </Layout>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/projects/Projects.js